import { render, staticRenderFns } from "./DNSObservability.vue?vue&type=template&id=09b1d159&scoped=true"
import script from "./DNSObservability.vue?vue&type=script&lang=js"
export * from "./DNSObservability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b1d159",
  null
  
)

export default component.exports